import React from 'react';

const ResultsTableRow = ({ rowData }) => {
  return (
    <tr className="Table__row Table__body-row">
      <td className="Table__col-grade">{rowData.Personal_Identifier}</td>
      <td className="Table__col-grade">{rowData.Student_Score}</td>
    </tr>
  );
};

export default ResultsTableRow;
